export enum ReleaseStatus {
  TakenDown = -1,
  Draft = 0,
  ToBeReleased = 2,
  Released = 3,
}
